/** Free tier caps (enforced in app; Pro / Business: unlimited for these features). */
export const FREE_TIER = {
  maxOwnedWorkspaces: 2,
  maxTasksPerWorkspace: 50,
  maxDocumentExtractions: 3,
} as const

export function isPaidPlan(plan: string | null | undefined): boolean {
  const p = (plan ?? "free").toLowerCase()
  return p === "pro" || p === "business"
}

export class WorkspaceLimitError extends Error {
  override readonly name = "WorkspaceLimitError"
}

export class TaskLimitError extends Error {
  override readonly name = "TaskLimitError"
}

export class ExtractionLimitError extends Error {
  override readonly name = "ExtractionLimitError"
}
